import Meetings from './Meetings';

export default Meetings;

